// apps/web/src/api/questions.ts
// 题目相关 API — 调用 /api/v1/banks/:bankId/questions/*

import api from "./client";
import type { QuestionDTO, CreateQuestionRequest, UpdateQuestionRequest, BatchImportQuestionsResponse } from "@examfast/shared-types";

const BASE = (bankId: string) => `banks/${bankId}/questions`;

/** 获取题目列表 */
export async function listQuestionsApi(
  bankId: string,
  opts: { page?: number; page_size?: number; type?: string; chapter?: string } = {}
) {
  const params = new URLSearchParams();
  if (opts.page) params.set("page", String(opts.page));
  if (opts.page_size) params.set("page_size", String(opts.page_size));
  if (opts.type) params.set("type", opts.type);
  if (opts.chapter) params.set("chapter", opts.chapter);
  const qs = params.toString();
  return api.get<QuestionDTO[]>(`${BASE(bankId)}${qs ? "?" + qs : ""}`);
}

/** 获取题目详情 */
export async function getQuestionApi(bankId: string, qid: string): Promise<QuestionDTO> {
  return api.get<QuestionDTO>(`${BASE(bankId)}/${qid}`);
}

/** 添加题目 */
export async function addQuestionApi(
  bankId: string,
  data: CreateQuestionRequest
): Promise<QuestionDTO> {
  return api.post<QuestionDTO>(BASE(bankId), data);
}

export async function batchImportQuestionsApi(
  bankId: string,
  questions: CreateQuestionRequest[],
): Promise<BatchImportQuestionsResponse> {
  return api.post<BatchImportQuestionsResponse>(`${BASE(bankId)}/batch`, { questions });
}

/** 更新题目 */
export async function updateQuestionApi(
  bankId: string,
  qid: string,
  data: UpdateQuestionRequest
): Promise<QuestionDTO> {
  return api.put<QuestionDTO>(`${BASE(bankId)}/${qid}`, data);
}

/** 删除题目 */
export async function deleteQuestionApi(bankId: string, qid: string): Promise<void> {
  return api.del<void>(`${BASE(bankId)}/${qid}`);
}
